module.exports = __webpack_public_path__ + "img/discovery.5d880c7b.svg";